import {Pipe, PipeTransform, inject} from '@angular/core';
import {Language} from '../../common/enums/language.enum';
import {QUESTION_NAME_FIELD_BY_LANGUAGE} from '../../common/constants/question-name-fields';
import {AppTranslateService} from '../../services/infrastructure/page/i18n/translate/app-translate/app-translate.service';
import {IQuestionItem} from '../../models/insurer-interview.model';

@Pipe({
  name: 'nameQuestion',
  pure: false,
})
export class NameQuestionPipe implements PipeTransform {

  private appTranslateService = inject(AppTranslateService);

  /**
   * Method: Read the question text in the current application language
   * @param value - The question record holding one text per language
   */
  transform(value: IQuestionItem): string {
    const currentLang = this.appTranslateService.getCurrentAppLanguage() as Language;
    const field = QUESTION_NAME_FIELD_BY_LANGUAGE[currentLang];
    return (field && value?.[field]) || '';
  }

}
